import { MouseEvent } from 'react';

export const hasTriggeredExtraClickFromKeyUpEvent = (
  event?: MouseEvent<HTMLButtonElement> | MouseEvent,
): boolean => {
  // A11y note: If a click event is fired by a keyboard (e.g, when a user tabs to focus a button and presses enter), the event is generated with the detail property as 0.
  // So, the below check is necessary to prevent this extra click (post-key-up) from unintentionally happening on the Next button by non-mouse users
  // N.B. we explicitly need 0 here as we still want e.g. users to submit answers with the number keys even if they're not in focus
  if (event?.detail === 0) return true;
  return false;
};
